<template>
  <LegalDocView type="shipping" :title="$t('shop.shipping_policy', 'Versandinformationen')">
    <!-- Built-in fallback, shown when no shipping text is maintained in the
         admin. Texts under legal.shipping.*. -->
    <section>
      <h2 class="font-heading text-xl font-bold text-white mb-3">{{ $t('legal.shipping.h_pod') }}</h2>
      <p>{{ $t('legal.shipping.pod') }}</p>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.shipping.h_times') }}</h3>
      <p class="mb-3">{{ $t('legal.shipping.times') }}</p>
      <ul class="list-disc list-inside space-y-1 ml-4">
        <li>{{ $t('legal.shipping.times_de') }}</li>
        <li>{{ $t('legal.shipping.times_eu') }}</li>
        <li>{{ $t('legal.shipping.times_world') }}</li>
      </ul>
      <p class="mt-3 text-sm">{{ $t('legal.shipping.vat') }}</p>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.shipping.h_tracking') }}</h3>
      <i18n-t keypath="legal.shipping.tracking" tag="p" scope="global">
        <template #orders><NuxtLink :to="localePath('/orders')" class="text-primary hover:underline">{{ $t('shop.my_orders') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.shipping.h_undeliverable') }}</h3>
      <p>{{ $t('legal.shipping.undeliverable') }}</p>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.shipping.h_cancel') }}</h3>
      <i18n-t keypath="legal.shipping.cancel" tag="p" scope="global">
        <template #withdrawal><NuxtLink :to="localePath('/widerrufsrecht')" class="text-primary hover:underline">{{ $t('shop.withdrawal_policy') }}</NuxtLink></template>
        <template #returns><NuxtLink :to="localePath('/rueckgabe')" class="text-primary hover:underline">{{ $t('shop.return_policy') }}</NuxtLink></template>
      </i18n-t>
    </section>
  </LegalDocView>
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({ layout: 'shop' })
const { t } = useI18n()
const localePath = useLocalePath()
useSeoMeta({
  title: () => t('shop.shipping_policy'),
  description: () => t('legal.shipping.meta_desc')
})
</script>
